import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OTPDelivery, OTPRequest } from 'app/model/tillotp';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService {

  constructor(private http: HttpClient) { }


  /**
   * @param {string} savingAccountId is saving account's Id.
   * @returns {Observable<any>}
   */
   getTillOTPDeliveryMethod(username: string): Observable<any> {
    const params = new HttpParams().set(`tillApproverUsername`, username);
    return this.http.get<Array<OTPDelivery>>(`/tillotp`,{params: params});
  }

  /**
   * @param {string} chargeId Charge ID of charge.
   * @returns {Observable<any>} Charge.
   */
  sendOTPToUser(delivery: string,request: OTPRequest): Observable<any> {
    const params = new HttpParams().set(`deliveryMethod`, delivery );
    return this.http.post(`/tillotp`,request,{params: params});
  }


}
